import line from "../src/images/Thanshiq/line.svg"
import log from "../src/images/Thanshiq/connectwith/Logation.svg"
import video from "../src/images/Thanshiq/connectwith/VideoCall.svg"
import whats from "../src/images/Thanshiq/connectwith/Whatsapp.svg"
import { useNavigate } from "react-router-dom"


function ConnectWith() {
  const navigate = useNavigate();

  const handleBkAp = () => { navigate('/BookAnAppointment') }
  const handleWhatsApp = () => { navigate(`https://api.whatsapp.com/send?phone="+91 09629157099"&text=`) }
  return (
    <div className="p-3 mb-5 ">
      <div className="text-center-center " style={{ textAlign: "center", borderRadius: "100px" }}>
        <h1 className=" HeadLine mt-2">
          Connect With Us
        </h1>
        <small className="jewellery">
          We are always available to guide you at your convenience.

        </small>
        < img src={line} style={{ width: "1200px" }} />

      </div>
      <div className="row" style={{ display: "flex", justifyContent: "center", gap: "20px" }}>

        <div
          style={{
            width: "400px",
            height: "150px",
            background: "#FDFAFA",
            border: "1px solid #8E1F2D",
            borderRadius: "4px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "15px",
            position: "relative",
          }}
        >
          <div >
            <a
              href={`https://api.whatsapp.com/send?phone="+91 09629157099"&text=Hii`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'none' }} // Remove underline from link
            >
              <p style={{ color: "#8E1F2D", margin: "0", fontSize: "14px" }}>
                Connect On
              </p>
              <h3 style={{ margin: "0", color: "#8E1F2D" }}>WhatsApp</h3>
              <button
                style={{
                  background: "#F8D7DA",
                  border: "none",
                  padding: "5px 15px",
                  marginTop: "10px",
                  cursor: "pointer",
                }}
              >
                Connect →
              </button>
            </a>
          </div>
          <img
            src={whats}
            alt="WhatsApp"
            style={{
              width: "80px", opacity: "0.4", transition: "transform 0.3s ease", marginRight: "px"
            }}

            onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
            onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
          />
        </div>


        <div
          onClick={handleBkAp}
          style={{
            width: "400px",
            height: "150px",
            background: "#FDFAFA",
            border: "1px solid #8E1F2D",
            borderRadius: "4px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "15px",
            position: "relative",
          }}
        >
          <div >
            <p style={{ color: "#8E1F2D", margin: "0", fontSize: "14px" }}>Book an</p>
            <h3 style={{ margin: "0", color: "#8E1F2D" }}>Appointment</h3>
            <button
              href="/BookAnAppointment"
              style={{
                background: "#F8D7DA",
                border: "none",
                padding: "5px 15px",
                marginTop: "10px",
                cursor: "pointer",
              }}
            >
              Book →
            </button>
          </div>
          <img src={log} alt="Appointment" style={{ width: "80px", opacity: "0.4" }} />
        </div>


        {/* <div
        onClick={handleBkAp}
          style={{
            width: "400px",
            height: "150px",
            background: "#FDFAFA",
            border: "1px solid #8E1F2D",
            borderRadius: "4px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "15px",
            position: "relative",
          }}
        >
          <div>
            <p style={{ color: "#8E1F2D", margin: "0", fontSize: "14px" }}>Schedule a</p>
            <h3 style={{ margin: "0", color: "#8E1F2D" }}>Video Call</h3>
            <button
              href="/BookAnAppointment"
              style={{
                background: "#F8D7DA",
                border: "none",
                padding: "5px 15px",
                marginTop: "10px",
                cursor: "pointer",
              }}
            >
              Schedule →
            </button>
          </div>
          <img
            src={video}
            alt="Video Call"
            style={{ width: "80px", opacity: "0.4" }}
          />
        </div> */}
      </div>
    </div >
  )
}
export default ConnectWith